// 埋点验证工具集成
export const pointValidateRegister = async (ubsData) => {
  ubsData?.use('PointValidate');
};
